module.exports = __webpack_public_path__ + "assets/M365_Files_light.png";